import React, { useEffect } from "react";
import { useRef, useState } from "react";
import { Form, Button, Row, Col, Spinner } from "react-bootstrap";
import API_BASE_URL from "../../config";
import { authFetch } from "../../utility/authFetch";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar";
import Header from "../../components/header";

function EditPatientDetails() {
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const [name, setName] = useState("");
  const [gender, setGender] = useState("");
  const [age, setAge] = useState("");
  const [contact, setContact] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [loader, setLoader] = useState(false);

  const { state } = useLocation();
  const navigate = useNavigate();
  const id = state?.data ?? null;

  useEffect(() => {
    if (!id) {
      console.error("No patient id provided in location state:", state);
      alert("Error fetching details");
      navigate(-1);
    }
  }, []);

  useEffect(() => {
    if (!id) return;
    const fetchPatient = async () => {
      try {
        const response = await authFetch(
          `${API_BASE_URL}/api/patient-details-follow-up-reg?id=${id}`
        );
        const result = await response.json();
        const patientDetails = result.patient;
        setName(patientDetails[1]);
        setGender(patientDetails[2]);
        setAge(patientDetails[3]);
        setContact(patientDetails[4]);
        setAddress(patientDetails[5]);
        setEmail(patientDetails[6]);
      } catch (error) {
        console.error("Error fetching patient:", error);
        alert("Error fetching details");
        navigate(-1);
      }
    };

    fetchPatient();
  }, []);

  const handleSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    setIsSubmitting(true);

    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      setIsSubmitting(false);
      setLoader(false);
      return;
    }

    const formData = new FormData(formRef.current);
    const url = `${API_BASE_URL}/api/edit-patient-details`;

    formData.append("id", id);

    const method = "POST";

    try {
      const response = await authFetch(url, {
        method,
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert("Patient Details updated successfully");
        formRef.current.reset();
        setIsSubmitting(false);
        setLoader(false);
        navigate(-1);
      } else {
        alert(result.error || "Error updating data");
        setIsSubmitting(false);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
      setIsSubmitting(false);
      setLoader(false);
    }
  };

  return (
    <div className="d-flex">
      {loader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(193, 193, 193, 0.7)",
            zIndex: 2000,
            pointerEvents: "all",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Sidebar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="container bg-white p-4 rounded shadow-sm">
            <div className="d-flex flex-row justify-content-between">
              <h5 className="mb-3">Edit Patient Details</h5>
              <Button onClick={() => navigate(-1)} variant="warning">
                Go Back
              </Button>
            </div>
            <Form onSubmit={handleSubmit} ref={formRef}>
              <Row className="align-items-end g-3">
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formPatientName">
                    <Form.Label>
                      Patient Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      required
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formGender">
                    <Form.Label>
                      Gender <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      aria-label="Category"
                      name="gender"
                      required
                      value={gender}
                      onChange={(e) => setGender(e.target.value)}
                    >
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formAge">
                    <Form.Label>
                      Age <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      value={age}
                      name="age"
                      onChange={(e) => setAge(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formContactNumber">
                    <Form.Label>
                      Contact Number <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="tel"
                      value={contact}
                      name="contactNumber"
                      required
                      autoComplete="off"
                      onChange={(e) => setContact(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formAddress">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter address"
                      name="address"
                      autoComplete="off"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter Email"
                      name="email"
                      autoComplete="off"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Button variant="primary" type="submit" disabled={isSubmitting}>
                UPDATE
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditPatientDetails;
